import JSZip from 'jszip';

/**
 * Base converter class with common EPUB creation functionality
 */
class BaseConverter {
  /**
   * Generate a UUID for EPUB identification
   */
  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  /**
   * Create the META-INF/container.xml file for EPUB
   */
  createContainerXml(epubZip) {
    const containerXml = `<?xml version="1.0" encoding="UTF-8"?>
<container version="1.0" xmlns="urn:oasis:names:tc:opendocument:xmlns:container">
    <rootfiles>
        <rootfile full-path="OEBPS/content.opf" media-type="application/oebps-package+xml"/>
    </rootfiles>
</container>`;
    
    epubZip.file('META-INF/container.xml', containerXml);
  }

  /**
   * Create the mimetype file for EPUB
   */
  createMimetypeFile(epubZip) {
    epubZip.file('mimetype', 'application/epub+zip');
  }

  /**
   * Get the EPUB filename from original filename
   */
  getEpubFileName(originalFileName) {
    return originalFileName
      .replace('.cbz', '.epub')
      .replace('.cbr', '.epub')
      .replace('.cb7', '.epub')
      .replace('.zip', '.epub')
      .replace('.docx', '.epub')
      .replace('.pdf', '.epub');
  }

  /**
   * Escape HTML entities in text
   */
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Check if a file is an image file
   */
  isImageFile(fileName) {
    const lowerCase = fileName.toLowerCase();
    return lowerCase.endsWith('.jpg') || lowerCase.endsWith('.jpeg') || 
           lowerCase.endsWith('.png') || lowerCase.endsWith('.gif') || 
           lowerCase.endsWith('.bmp') || lowerCase.endsWith('.webp');
  }

  /**
   * Get MIME type for image files
   */
  getImageMimeType(fileName) {
    const lowerCase = fileName.toLowerCase();
    if (lowerCase.endsWith('.jpg') || lowerCase.endsWith('.jpeg')) {
      return 'image/jpeg';
    } else if (lowerCase.endsWith('.png')) {
      return 'image/png';
    } else if (lowerCase.endsWith('.gif')) {
      return 'image/gif';
    } else if (lowerCase.endsWith('.bmp')) {
      return 'image/bmp';
    } else if (lowerCase.endsWith('.webp')) {
      return 'image/webp';
    }
    return 'image/jpeg';
  }

  /**
   * Calculate new image dimensions while maintaining aspect ratio
   */
  calculateNewSize(originalWidth, originalHeight, maxWidth, maxHeight) {
    let newWidth = originalWidth;
    let newHeight = originalHeight;
    
    if (originalWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = (originalHeight * maxWidth) / originalWidth;
    }
    
    if (newHeight > maxHeight) {
      newHeight = maxHeight;
      newWidth = (originalWidth * maxHeight) / originalHeight;
    }
    
    return { width: Math.round(newWidth), height: Math.round(newHeight) };
  }

  /**
   * Generate EPUB blob from JSZip instance
   */
  async generateEpubBlob(epubZip, compressionLevel = 6) {
    return await epubZip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      compressionOptions: { level: compressionLevel }
    });
  }
}

export default BaseConverter;
